import { useIsSuperAdmin } from '@savgroup-front-common/core/hooks';

const useHasTenantThemePermission = (): boolean => {
  return useIsSuperAdmin();
};

export default useHasTenantThemePermission;
